import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { getInlineLoader } from "../Helpers";

import OneProject from "./OneProject";

export default function ProjectsBanner(props) {

  const appContext = useContext(AppContext);

  /* Place states here */
  const [ready, setReady] = useState(false);

  async function init() {
    setReady(false);
    await Promise.all([
      appContext.getAllProjects(),
    ]);
    setReady(true);
  }

  useEffect(() => {
    init();
  }, []);

  if (ready) {
    return (
      <div
        className="MainBodySection bg-background"
        style={{
          paddingTop: "50px",
          paddingBottom: "50px"
        }}
      >
        <div className="container">

          {/* Header */}
          <div className="row justify-content-center mb-5 text-center">
            <div className="col-lg-8">
              <h2 className="font-bold mb-3" >
                Our Projects
              </h2>
              <p className="text-dim" >
                Explore various videos showcasing our projects
              </p>
            </div>
          </div>


          <div className="row">
            {
              (appContext.allProjects && appContext.allProjects.length > 0)
                ? appContext.allProjects.map((item, i) => (
                    <div key={i} className="col-md-6">
                      <OneProject data={item} />
                    </div>
                  ))
                : (
                  <div className="col-md-12 mb-1 mt-1">
                    <h6>No data was found</h6>
                  </div>
                )
            }

          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div className="container mSupportLoading">
        {getInlineLoader()}
      </div>
    );
  }
}
